import { omit } from 'lodash';
import { useDispatch } from 'react-redux';
import VoiceConfiguration from 'src/models/Channels/VoiceConfiguration';

const useOnSave = () => {
  const dispatch = useDispatch();
  return ({ item, resetErrors, update, validate, workingStateRef }) => {
    dispatch(resetErrors());
    const currentWorkingState = workingStateRef.current;
    const workingStateToUpdate = {
      ...omit(currentWorkingState, ['initialIvrName', 'queueIvrName']),
      initialIvrId: currentWorkingState.initialIvrId || undefined,
      queueIvrId: currentWorkingState.queueIvrId || undefined,
    } as VoiceConfiguration;

    if (!dispatch(validate(workingStateToUpdate))) {
      return;
    }

    dispatch(
      update({ id: item.id }, workingStateToUpdate, {
        customToastMsg: `Updated voice configuration for ${workingStateToUpdate.number}`,
      })
    );
  };
};

export default useOnSave;
